import { useState } from 'react';
import { post, errorMessage } from '../api';
import { useLibrary } from '../library';
import { toast } from './toast';

/**
 * Shown when the library has no public holiday set for a year: offers to
 * calculate one from the Public Holidays Act rules. The set is marked
 * unverified until someone checks it against the Government Gazette.
 */
export function HolidayOffer({ year }: { year: number }) {
  const load = useLibrary((s) => s.loadEventSets);
  const [busy, setBusy] = useState(false);
  if (year < 1995 || year > 2100) return <span className="small faint">No public holiday data for {year} in the library.</span>;
  return (
    <div className="notice warn small row wrap" style={{ gap: 8 }}>
      <span className="grow">No public holiday data for {year} in the library yet.</span>
      <button type="button" className="btn sm" disabled={busy} onClick={async () => {
        setBusy(true);
        try { await post('/api/event-sets/generate-za', { year }); await load(); toast(`Calculated ${year} public holidays added (unverified)`, 'ok'); }
        catch (e) { toast(errorMessage(e), 'err'); }
        finally { setBusy(false); }
      }}>{busy ? 'Calculating…' : `Calculate ${year} SA public holidays (unverified)`}</button>
    </div>
  );
}

/** Why a Create button is disabled, or null when it is enabled. */
export function createBlocker(f: { name: string; year: number }): string | null {
  if (!f.name.trim()) return 'Enter a project name';
  if (!(f.year >= 1900 && f.year <= 2100)) return 'Enter a year between 1900 and 2100';
  return null;
}
